import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

const PaymentSuccessPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Optional: get pack info from location state
  const pack = location.state;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2>Payment Successful!</h2>

        {pack && (
          <p>
            You have successfully renewed the <strong>{pack.name}</strong> license.
          </p>
        )}

        <p>Thank you for your payment.</p>

        <button style={styles.button} onClick={() => navigate("/dashboard")}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#f3f4f6"
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "10px",
    textAlign: "center",
    width: "350px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)"
  },
  button: {
    marginTop: "20px",
    padding: "10px",
    width: "100%",
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  }
};

export default PaymentSuccessPage;